import { PageController } from '@client/components/_core/layout/PageController';
import { CommunicationSignatureEdit } from '@client/components/communication-templates/CommunicationSignatureEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/org-settings/communication/comm-signatures/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New communication signature',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <CommunicationSignatureEdit action={['add']} />
        </PageController>
    );
}
